<template>
    <ul class="pagination pagination-circled mt-4" v-if="pages.length">
        <li class="page-item" v-if="currentPage > 1">
            <a class="page-link" href="#" @click="prevPageMethod">
                <i class="icon ion-ios-arrow-forward"></i>
            </a>
        </li>
        <li v-for="(page,index) in pages.filter((page) => Math.abs(page - currentPage) < 3)" :key="index" :class="'page-item ' + (page == currentPage ? 'active' : '')">
            <a class="page-link" href="#" @click="e => changePageMethod(e,page)">{{ page }}</a>
        </li>
        <li class="page-item" v-if="pages.length > currentPage + 3">
            <a class="page-link">...</a>
        </li>
        <li class="page-item" v-if="pages.length > currentPage + 3">
            <a class="page-link" href="#" @click="e => changePageMethod(e,pages.length)">{{ pages.length }}</a>
        </li>
        <li class="page-item" v-if="pages.length != currentPage">
            <a class="page-link" href="#" @click="nextPageMethod">
                <i class="icon ion-ios-arrow-back"></i>
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'Pagination',
        props: ['pages','currentPage','prevPageMethod','nextPageMethod','changePageMethod']
    }
</script>